module.exports = __webpack_public_path__ + "drop-menu-s.96a85ba0b5183039afb435bb6df9e47f.png";